<script>
import API from '../../services/api.js';
import VueCharts from 'vue-chartjs'
import {
	Line
} from 'vue-chartjs'

import {
	mapMutations
} from 'vuex';

const api = new API();

export default {
	extends: Line,
	mounted() {
		this.plot();
	},
	methods: {
		plot() {
			api.getProgressChart("weight").then(response => {
				if (response.data.success) {
					var labels = [];
					var dataset = {
						label: "Weight",
						backgroundColor: '#33B1E5',
						data: []
					}

					var progress_records = response.data.data;
					for (var p in progress_records) {
						labels.push(progress_records[p].date);
						dataset.data.push(this.$store.getters.user.meta_data.preferred_units == "metric" ? progress_records[p].value : progress_records[p].imperial_value);
					}

					this.renderChart({
						labels: labels,
						datasets: [dataset],
					}, {responsive: true, maintainAspectRatio: false});
				} else {}
			});
		}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/WeightProgressChart.vue